export enum ELaForgeWorkerEnum {
  Employee = "worker",
  Contractor = "contractor",
}
